import React from 'react'
import { Link } from 'react-router-dom';


function ServiceEleven() {
    return (
        <div>
            {/* rts service post area  Start*/}
            <div className="rts-service-area rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="rts-title-area service text-center">
                                <p className="pre-title">Nos Services</p>
                                <h2 className="title">Détails des domaines d'activités</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid service-main plr--120-service mt--50 plr_md--0 pl_sm--0 pr_sm--0">
                    <div className="background-service row">
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner one">
                                <div className="service-details">
                                    <Link to={'/service/prestations-service-on-off-shore'}>
                                        <h5 className="title">Prestations de service On/Off Shore</h5>
                                    </Link>
                                    <p className="disc">
                                        Externaliser certaines activités permet aux entreprises d'optimiser leur fonctionnement. Nous sous-traitons vos activités pétrolières en mer et à terre.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/service/prestations-service-on-off-shore'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        En savoir plus
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner two">
                                <div className="service-details">
                                    <Link to={'/service/transit'}>
                                        <h5 className="title">Service Transit</h5>
                                    </Link>
                                    <p className="disc">
                                        Traçabilité permanente des marchandises, respect des procédures internationales, stockage, emballage et coordination avec transporteurs, assurances et douanes.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/service/transit'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        En savoir plus
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner three">
                                <div className="service-details">
                                    <Link to={'/service/fourniture-materiaux-construction'}>
                                        <h5 className="title">Fourniture de matériaux de construction</h5>
                                    </Link>
                                    <p className="disc">
                                        Matériels de plomberie, électricité, carrelage, climatisation, EPI. Service après-vente disponible pour suivi et maintenance.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/service/fourniture-materiaux-construction'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        En savoir plus
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner four">
                                <div className="service-details">
                                    <Link to={'/service/construction-btp-genie-civil'}>
                                        <h5 className="title">Construction BTP &amp; Génie civil</h5>
                                    </Link>
                                    <p className="disc">
                                        Experts du secteur, nous offrons construction, rénovation et aménagement avec engagement de qualité, fiabilité et respect des délais.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/service/construction-btp-genie-civil'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        En savoir plus
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner five">
                                <div className="service-details">
                                    <Link to={'/service/fourniture-equipements-industriels'}>
                                        <h5 className="title">Fourniture d'équipements &amp; matériels industriels</h5>
                                    </Link>
                                    <p className="disc">
                                        Produits de nettoyage, entretien pour forages, lubrifiants, outillage, matériel de soudage et EPI spécialisés.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/service/fourniture-equipements-industriels'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        En savoir plus
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner six">
                                <div className="service-details">
                                    <Link to={'/service/nettoyage-industriel-assainissement'}>
                                        <h5 className="title">Nettoyage industriel &amp; assainissement</h5>
                                    </Link>
                                    <p className="disc">
                                        Solutions professionnelles pour hygiène, propreté, assainissement et sécurité. Location et vente d'échafaudages, tubes galvanisés et planchers.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/service/nettoyage-industriel-assainissement'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        En savoir plus
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner seven">
                                <div className="service-details">
                                    <Link to={'/service/fourniture-equipement-general'}>
                                        <h5 className="title">Fourniture d'équipement général pour entreprises</h5>
                                    </Link>
                                    <p className="disc">
                                        Matériels administratifs : mobiliers, papeterie. Matériels informatiques : ordinateurs, imprimantes, photocopieuses, consommables.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/service/fourniture-equipement-general'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        En savoir plus
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner eight">
                                <div className="service-details">
                                    <Link to={'/service/mise-disposition-personnel'}>
                                        <h5 className="title">Mise à disposition du personnel</h5>
                                    </Link>
                                    <p className="disc">
                                        Personnel qualifié : agents de construction, agents de sécurité, techniciens de surface, agents d'entretien et maintenance. Autres profils sur demande.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/service/mise-disposition-personnel'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        En savoir plus
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                        {/* start single Service */}
                        <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="service-one-inner nine">
                                <div className="service-details">
                                    <Link to={'/service/transport-logistique'}>
                                        <h5 className="title">Transport &amp; logistique</h5>
                                    </Link>
                                    <p className="disc">
                                        Transport routier, maritime, aérien, ferroviaire. Déplacement de personnes, acheminement sécurisé des colis et marchandises avec planification complète.
                                    </p>
                                    <Link
                                        className="rts-read-more btn-primary"
                                        to={'/service/transport-logistique'}
                                    >
                                        <i className="far fa-arrow-right" />
                                        En savoir plus
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* end single Services */}
                    </div>
                </div>
            </div>
            {/* rts service post area ENd */}

        </div>
    )
}

export default ServiceEleven